import type { DexPaneWrapperProps } from "./components/DexPaneWrapper";
import type * as lazyIndex from "./lazyIndex";
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ProofingPluginDexPane" */ "./lazyIndex"), { name: "ProofingPluginDexPane" });

export const DexPaneWrapper: LazyComponent<DexPaneWrapperProps, unknown, void> = createLazyComponent(lazyModule, m => m.DexPaneWrapper);
export const lazyCloseDexPane: LazyAction<typeof lazyIndex.closeDexPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.closeDexPane);
